module.exports = {
  context: {
    sectionHeading: 'Example Section Heading',
    text: '<p>sample raw html</p>'
  }
}
